import logo from '../../../../assets/report-logo.svg';
import { formatEventDate } from '../../../../utils/EventFormatting.util';
import { Classification } from '../../../ui/Classification/Classification';
import { Divider } from '../../../ui/Divider/Divider';
import { ReportHeaderProps } from './ReportHeader.types';

export function ReportHeader({ componentInfo }: ReportHeaderProps) {
  const capitalizeFirstLetter = (text: string) => {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  const fields = [
    {
      label: componentInfo.entityType.label,
      value: capitalizeFirstLetter(componentInfo.entityType.value)
    },
    {
      label: componentInfo.systemName.label,
      value: componentInfo.systemName.value
    },
    { label: componentInfo.version.label, value: componentInfo.version.value },
    {
      label: componentInfo.organizationName.label,
      value: componentInfo.organizationName.value
    },
    {
      label: componentInfo.provider.label,
      value: componentInfo.provider.value
    }
  ];

  return (
    <div className="flex flex-col border border-gray-100 rounded-lg p-4">
      <div className="flex flex-row justify-between">
        <h1 className="text-zinc-900 text-lg font-semibold text-left">
          {componentInfo.title}
        </h1>
        <img src={logo} alt="euaiaudit logo" className="h-8 w-auto" />
      </div>
      <Divider classes="my-[14px]" />
      <div className="flex justify-between">
        <div className="flex flex-col gap-4">
          {fields.map((field) => {
            const value = field.value ?? '';

            return (
              <div key={field.label} className="flex flex-col gap-1 items-start">
                <span className="text-xs leading-5 text-gray-550 font-medium uppercase text-nowrap">
                  {field.label}:
                </span>
                <span
                  title={value.length > 50 ? value : undefined}
                  className="text-base text-gray-900 font-medium"
                >
                  {value.length > 50
                    ? value.slice(0, 47).concat('...')
                    : value}
                </span>
              </div>
            );
          })}
        </div>

        <div className="flex flex-col justify-between">
          <Classification
            risk={componentInfo.classification.risk}
            text={componentInfo.classification.text}
          />
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2 items-end">
              <span className="text-xs leading-5 text-gray-550 font-medium uppercase">
                {componentInfo.labels?.generatedLabel ?? 'Generated'}:
              </span>
              <span className="text-gray-900 font-medium">
                {formatEventDate(componentInfo.generatedTime)}
              </span>
            </div>
            <div className="flex flex-col gap-2 items-end">
              <span className="text-xs leading-5 text-gray-550 font-medium uppercase">
                {componentInfo.labels?.idLabel ?? 'Report Id'}:
              </span>
              <span className="text-gray-900 font-medium">
                {componentInfo.reportId || 'EUAIA-2025-I6XGDOCRC'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
